"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommunityChannelsElementsLists = useCommunityChannelsElementsLists;
var _constants = require("../../../utils/constants");
var _lodash = require("lodash");
var _react = require("react");
function useCommunityChannelsElementsLists(chatPreviewElements) {
  var elements = (0, _react.useMemo)(function () {
    return (0, _lodash.reduce)(chatPreviewElements, function (acc, el) {
      var channel = el.props.channel;
      if (channel.id === _constants.COMMUNITY_EMERGENCY_RESOURCES_CHANNEL_ID) {
        acc.emergencyResourcesChatElement = el;
        return acc;
      }
      if (Object.values(_constants.SUPPORT_GROUP_CHANNEL_TYPES).includes(channel.type)) {
        acc.groupChatsElements.push(el);
        return acc;
      }
      if (channel.type === _constants.COMMUNITY_CHANNEL_TYPES.GETTING_STARTED) {
        acc.gettingStartedChatsElements.push(el);
        return acc;
      }
      acc.conversationsChatsElements.push(el);
      return acc;
    }, {
      gettingStartedChatsElements: [],
      groupChatsElements: [],
      conversationsChatsElements: [],
      emergencyResourcesChatElement: null
    });
  }, [chatPreviewElements]);
  return elements;
}